import { render, staticRenderFns } from "./RouteToTransaction.vue?vue&type=template&id=8592400a&scoped=true&"
import script from "./RouteToTransaction.vue?vue&type=script&lang=js&"
export * from "./RouteToTransaction.vue?vue&type=script&lang=js&"
import style0 from "./RouteToTransaction.vue?vue&type=style&index=0&id=8592400a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8592400a",
  null
  
)

export default component.exports